import { render, staticRenderFns } from "./rankResultsForm.vue?vue&type=template&id=da9a5626"
import script from "./rankResultsForm.vue?vue&type=script&lang=js"
export * from "./rankResultsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports